import { FiHeart, FiMapPin, FiPackage, FiUser } from "react-icons/fi";
import { accountHref } from "@/shared/routes";

/** Links de conta compartilhados pelo dropdown desktop e pelo sheet mobile. */
export const ACCOUNT_LINKS = [
    { href: accountHref(), label: "Minha conta", Icon: FiUser },
    { href: accountHref("meus-pedidos"), label: "Meus pedidos", Icon: FiPackage },
    { href: accountHref("enderecos"), label: "Meus endereços", Icon: FiMapPin },
    { href: accountHref("favoritos"), label: "Favoritos", Icon: FiHeart },
] as const;
